import PostalKit from '../../ports-frontend/PostalKit';

import { createLogger } from '../utils/logger';

const logger = createLogger('account.unity');

export function openDeposit() {
  PostalKit.publishEvent({
    channel: 'pam',
    topic: 'events',
    data: { event: 'pam.event.deposit.open' },
  });
}

export function hideBalance() {
  logger.log('hide balance action');
  // TODO: dependency on MTT-2658
}

export function showBalance() {
  logger.log('show balance action');
  // TODO: dependency on MTT-2658
}
